import lazysizes from 'lazysizes';

require('lazysizes/plugins/respimg/ls.respimg');
require('lazysizes/plugins/object-fit/ls.object-fit');
require('lazysizes/plugins/parent-fit/ls.parent-fit');

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

document.addEventListener('AppReady', lazysizes.init);
